import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import favicon from './assets/logos/fresh-start-landscaping-favicon (1).png';

const faviconLink =
  document.querySelector("link[rel='icon']") || document.createElement('link');
faviconLink.setAttribute('rel', 'icon');
faviconLink.setAttribute('href', favicon);
if (!faviconLink.parentNode) {
  document.head.appendChild(faviconLink);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
